<template>
  <v-menu
    v-model="ltxFilterDropDown.customer"
    content-class="bg-white"
    left
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        filled
        flat
        label="Select Customer"
        hide-details
        solo
        readonly
        color="cyan"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        append-icon="$dropdown"
        :value="
          ltxFilter?.customer?.id
            ? `${ltxFilter?.customer?.barcode} - ${ltxFilter?.customer?.display_name}`
            : ''
        "
        :class="{ 'menu-open': ltxFilterDropDown.customer }"
        :loading="ltxFilterLoading.customer"
      />
    </template>
    <v-list height="500px" class="py-0" color="cyan--text" dense>
      <v-list-item
        class="custom-border-bottom bg-white"
        style="position: sticky; top: 0; z-index: 9999"
      >
        <v-list-item-content>
          <div class="d-flex">
            <v-text-field
              clearable
              dense
              filled
              flat
              class="pl-0"
              label="Search Customer..."
              hide-details
              solo
              v-model="filterSearch"
              color="cyan"
              v-on:keyup.enter="filterCustomer()"
              :disabled="ltxFilterLoading.customer"
              :loading="ltxFilterLoading.customer"
            />
            <v-btn
              v-on:click="filterCustomer()"
              :disabled="ltxFilterLoading.customer"
              style="min-height: 32px"
              depressed
              color="cyan white--text"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="ltxFilterLoading.customer" dense class="filter-loader">
        <v-skeleton-loader size="40" class="px-0" type="list-item-avatar" />
        <v-list-item-content class="text-ellipsis max-width-400px">
          <v-list-item-subtitle
            class="text-capitalize font-weight-500 font-size-16"
            style="line-height: unset"
          >
            <v-skeleton-loader type="chip" />
          </v-list-item-subtitle>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16"
            style="line-height: unset"
          >
            <v-skeleton-loader type="text" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        dense
        selectable
        v-for="(item, index) in ltxFilterCustomerList"
        :input-value="ltxFilter?.customer?.id == item.id"
        :key="`customer-filter-${index}`"
        v-on:click="onClickEvent(item)"
      >
        <v-list-item-avatar
          height="40"
          min-width="40"
          width="40"
          class="mr-2 my-2 grey lighten-2 grey--text"
        >
          <v-img v-if="item?.profile_logo" :src="item.profile_logo" />
          <span v-else class="fw-600 mb-1 font-size-20">{{
            item?.display_name?.slice(0, 2).toUpperCase()
          }}</span>
        </v-list-item-avatar>
        <v-list-item-content class="text-ellipsis max-width-400px">
          <v-list-item-subtitle
            class="text-capitalize font-weight-500 font-size-16"
            style="line-height: unset"
          >
            <span class="filter-list-barcode">{{ item?.barcode }}</span>
          </v-list-item-subtitle>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16"
            style="line-height: unset"
          >
            {{ item?.display_name }}
          </v-list-item-title>
          <v-list-item-subtitle
            class="text-capitalize font-weight-500 font-size-16"
            style="line-height: unset"
          >
            {{ item?.company_name }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action
          class="align-self-center my-0"
          v-if="ltxFilter?.customer?.id == item.id"
        >
          <v-icon color="cyan">mdi-check</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import {
  SET_STATE,
  GET_CUSTOMER,
  GET_PROPERTY,
  GET_PERSON,
} from "@/core/services/store/filter.module";

export default {
  name: "customer-filter",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterSearch: null,
      filterTimeout: null,
      filterTimeoutLimit: 0,
    };
  },
  watch: {
    "ltxFilterDropDown.customer"(param) {
      if (!param && this.filterSearch) {
        this.filterSearch = null;
        this.filterCustomer();
      }
    },
  },
  methods: {
    onClickEvent(item) {
      if (!item?.id || item?.id == "UNDEFINED") {
        return false;
      }

      this.setFilterState("db_filter_dropdown.customer", false);
      this.setFilterState("db_filter.customer", item);

      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.getPerson();
        this.getProperty();
      }, this.filterTimeoutLimit);

      this.$emit("change", item);
    },
    getProperty() {
      this.setFilterState("db_filter.property", null);
      this.$store.dispatch(GET_PROPERTY);
    },
    getPerson() {
      this.setFilterState("db_filter.person", null);
      this.$store.dispatch(GET_PERSON);
    },
    filterCustomer() {
      this.setFilterState("db_filter_customers", []);
      this.$store.dispatch(GET_CUSTOMER, { search: this.filterSearch });
    },
    setFilterState(key, value) {
      this.$store.commit(SET_STATE, { key, value });
    },
  },
  computed: {
    ...mapGetters([
      "ltxFilter",
      "ltxFilterDropDown",
      "ltxFilterCustomerList",
      "ltxFilterLoading",
    ]),
  },
};
</script>
